import type { Challenge } from '../types/journey'

import type { ProgressRewards } from '@/shared/types/user-progress'

interface CalcLevelRewardsParams {
  level: { point_reward?: number; coin_reward?: number }
  challenges: Challenge[]
  /** Desafios respondidos corretamente (progress.correct_challenges). */
  correctChallengeIds: Set<number>
  /** Desafios respondidos, certos ou errados (progress.finished_challenges). */
  finishedChallengeIds: Set<number>
  /** Nível concluído (progress.finished_levels) — é o que credita o bônus. */
  levelFinished: boolean
}

export interface LevelRewards extends ProgressRewards {
  finishedChallenges: number
  allChallengesFinished: boolean
}

/**
 * Placar de aproveitamento do nível — mesma regra da jornada
 * ([[calcJourneyRewards]]): desafio só pontua quando respondido corretamente e
 * o bônus do nível só entra quando o nível é concluído, que é quando a api
 * cria o ProgressResource do Level e credita a carteira.
 */
export function calcLevelRewards({
  level,
  challenges,
  correctChallengeIds,
  finishedChallengeIds,
  levelFinished
}: CalcLevelRewardsParams): LevelRewards {
  const rewards: LevelRewards = {
    acquiredCoins: 0,
    acquiredPoints: 0,
    totalCoins: level.coin_reward ?? 0,
    totalPoints: level.point_reward ?? 0,
    finishedChallenges: 0,
    allChallengesFinished: true
  }

  for (const challenge of challenges) {
    rewards.totalCoins += challenge.coin_reward ?? 0
    rewards.totalPoints += challenge.point_reward ?? 0

    if (!finishedChallengeIds.has(challenge.id)) {
      rewards.allChallengesFinished = false
      continue
    }

    rewards.finishedChallenges++

    if (correctChallengeIds.has(challenge.id)) {
      rewards.acquiredCoins += challenge.coin_reward ?? 0
      rewards.acquiredPoints += challenge.point_reward ?? 0
    }
  }

  if (levelFinished) {
    rewards.acquiredCoins += level.coin_reward ?? 0
    rewards.acquiredPoints += level.point_reward ?? 0
  }

  return rewards
}
